import { Component, useContext, useEffect, useMemo, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { withFormik, Form } from "formik";
import { FormRow } from "../Form/Form";
import DialogComponentWrapper from "../Utils/DialogComponentWrapper";
import PromiseWrapper from "../Utils/PromiseDialog";
import LoadingDialog from "../Utils/LoadingDialog";
import { toast } from "react-toastify";


import { icon } from "@fortawesome/fontawesome-svg-core";
import { faTrashAlt, faCheckCircle, faTimesCircle, faPlus, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import { RestAPI } from "@aws-amplify/api-rest";

import DivPortal from "../Utils/DivPortal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TypesContext } from "../../contexts/TranslatedTypes";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import { Button } from "primereact/button";
import DropdownPrime from "../PrimeComponents/DropdownPrime";
import { FarmContext } from "../../contexts/FarmContext";

const [deleteIcon] = icon(faTrashAlt, { styles: { "color": "tomato" } }).html;
const [addIcon] = icon(faPlus, { styles: { "color": "#333333", "width": "18px", "height": "22px" } }).html;
const [cancelIcon] = icon(faTimes, { styles: { "color": "#333333", "width": "18px", "height": "22px" } }).html;
const [clearIcon] = icon(faTrash, { styles: { "color": "#333333", "width": "18px", "height": "22px" } }).html;


const customAttributes = { class: "customcss" };

const onFiltering = (e, dataSource) => {
    if (dataSource) {
        if (e.text === "") {
            e.updateData(dataSource);
        } else {
            const query = dataSource.filter((data) => data.nombre.toLowerCase().search(e.text.toLowerCase()) !== -1);
            e.updateData(query);
        }
    }
};

const EditNutrientsTable = ({ names, tableNutrientes, setTableNutrientes, nutrientes, listaNutrientes, t, fertilizante_id }) => {
    const [disabled, setDisabled] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [currentNutriente, setCurrentNutriente] = useState(null);
    const promiseWrapper3 = useRef(null);
    const promiseWrapper4 = useRef(null);
    const percentRef2 = useRef(null);
    const copiaNutrientes = useMemo(() => {
        if(nutrientes && nutrientes.slice(0)){
            setTableNutrientes(nutrientes && nutrientes.slice(0));
        }else{
            setTableNutrientes([]);

        }
        return nutrientes && nutrientes.slice(0);
    }, [nutrientes]);
    const [maxRecom2, setMaxRecom2] = useState(null);
    const btnVerdeRef2 = useRef(false);

    const clearInputs = () => {
        if (percentRef2.current) {
            percentRef2.current.value = null;
        }
        setCurrentNutriente(null);
    };

    const { templatePorcentaje } = useMemo(() => {

        const templatePorcentaje = ({ porcentaje }) => {
            if (porcentaje === null || porcentaje === undefined) return "-";
            return (<span className="param-properties">{t("general.number_unit", { value: { number: porcentaje, unit: "%" } })}</span>);
        };

        return { templatePorcentaje };
    }, [t]);

    return (
        <div>
            <PromiseWrapper
                ref={promiseWrapper3}
                yesText={t("general.answerYes")} noText={t("general.answerNo")}
                headerText={t("general.confirm")} contentText={t("forms.clearTableMsg")}
            />
            <PromiseWrapper
                ref={promiseWrapper4}
                yesText={t("general.answerYes")} noText={t("general.answerNo")}
                headerText={t("general.confirm")} contentText={t("forms.borrarNutMsg")}
            />
            <div className="row">
                <div className="col">
                    <div className="collapse multi-collapse" id="multiCollapse2" style={{ paddingTop: "30px" }}>
                        <div className="card card-body">
                            <div className="row">
                                <div className='col text-center'>
                                    <h6><span className="card-title">{!isEditing ? t("forms.addNutriente") : t("forms.editNutriente")}</span></h6>
                                </div>

                            </div>
                            <div className="linea-titulo" />
                            <div className="row linea-formulario">
                                <div className="col-2">
                                    <label className="boldie">{t("forms.nutriente")}</label>
                                </div>
                                <div className="mb-2 col-4 d-block text-left">
                                    <div id="ddl-content" hidden={isEditing}>
                                        <DropdownPrime
                                            small
                                            value={currentNutriente}
                                            onChange={(e) => {
                                                setCurrentNutriente(e.value);
                                                if (currentNutriente?.porcentaje) {
                                                    setDisabled(false);
                                                    percentRef2.current.value=currentNutriente?.porcentaje;
                                                }
                                            }}
                                            options={listaNutrientes} optionLabel="nombre"
                                            placeholder={t("forms.pHolderSelect")}
                                            name="ddlNutrientes"
                                        />
                                    </div>
                                    <div id="nut-content" hidden={!isEditing}>
                                        <label >{currentNutriente?.nombre}</label>
                                        <input value={currentNutriente?.nutriente_id} type="hidden" />
                                    </div>
                                </div>

                                <div className="col-2">
                                    <label className="boldie">{t("forms.porcentaje")}</label>
                                </div>
                                <div className="col-4 d-block">
                                    <div className="p-0 unit-input-content">
                                        <input ref={percentRef2} id="porcentaje2" placeholder={0} min={0} max={100} step={0.01} /* step=".01" */
                                            name="porcentaje" className="e-control e-dropdownlist e-input" type="number"
                                            onChange={(e) => {
                                                /* btnVerdeRef2.current.disabled = false; */
                                                setMaxRecom2(null);
                                                if (percentRef2.current && percentRef2.current.value > 100) percentRef2.current.value = 100;
                                                if (percentRef2.current && percentRef2.current.value < 0) percentRef2.current.value = 0;
                                                if (tableNutrientes) {
                                                    let per = 0;
                                                    tableNutrientes.forEach(d => {
                                                        per = per + d.porcentaje;
                                                    });
                                                    const recomm = 100 - per;
                                                    if (percentRef2.current && percentRef2.current.value > recomm) {
                                                        setMaxRecom2(t("forms.percentMsg"));
                                                    }
                                                }
                                            }}
                                        />
                                        <p className="unit-edit">%</p>
                                    </div>
                                </div>
                            </div>


                            <div className="row pt-2">
                                <div className="col-6 text-right">
                                    <button ref={btnVerdeRef2} className='border-0 bg-transparent p-0'
                                        data-toggle="collapse"
                                        data-target=".multi-collapse" aria-expanded="false"
                                        aria-controls="multiCollapse1 multiCollapse2"
                                    >
                                        <FontAwesomeIcon id="greenCheckIcon2" name="greenCheckIcon2" className='btnEdit pointer' size="lg" style={{ color: "blue" }}
                                            icon={faCheckCircle}
                                            onClick={(e) => {
                                                if (isEditing) {

                                                    const nutriente = currentNutriente;
                                                    const porcentaje = percentRef2.current.value;

                                                    const objNutriente = {
                                                        fertilizante_id: fertilizante_id,
                                                        nutriente_id: parseInt(nutriente?.nutriente_id),
                                                        nombre: nutriente?.nombre,
                                                        porcentaje: parseFloat(porcentaje)
                                                    };
                                                    const index = tableNutrientes?.findIndex(m => m.nutriente_id === objNutriente.nutriente_id);
                                                    if(index >=0){
                                                        tableNutrientes[index] = objNutriente;
                                                    }else{
                                                        tableNutrientes.push(objNutriente);
                                                    }

                                                } else {
                                                    const porcentaje = percentRef2.current.value;
                                                    const ddlValue = currentNutriente.nutriente_id;
                                                    if (ddlValue && porcentaje) {

                                                        if ((Array.isArray(tableNutrientes) && !tableNutrientes.filter(n => n.nutriente_id === ddlValue).length)
                                                            || tableNutrientes === null) {
                                                            const nutriente = listaNutrientes.find(n => n.nutriente_id == ddlValue);
                                                            const objNutriente = {
                                                                fertilizante_id: fertilizante_id,
                                                                nutriente_id: parseInt(nutriente.nutriente_id),
                                                                nombre: nutriente.nombre,
                                                                porcentaje: parseFloat(porcentaje)
                                                            };
                                                            tableNutrientes.push(objNutriente);
                                                        }
                                                    }
                                                }
                                                /* if (ddlNutrientes.current.value) setDisabled(false); */
                                            }}
                                        >{t("forms.save")}</FontAwesomeIcon>
                                    </button>
                                </div>

                                <div className="col-6 text-left">
                                    <button type="button" className='border-0 bg-transparent p-0'
                                        data-toggle="collapse"
                                        data-target=".multi-collapse" aria-expanded="false"
                                        aria-controls="multiCollapse1 multiCollapse2"
                                        onClick={(e) => {
                                            clearInputs();
                                            /* setDisabled(false) */
                                            setMaxRecom2(null);
                                        }}
                                    >
                                        <FontAwesomeIcon className='btnEdit pointer' size="lg" style={{ color: "tomato" }} icon={faTimesCircle}>{t("forms.cancel")}</FontAwesomeIcon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <span className="param-properties spanErrorMsg">{maxRecom2}</span>
            <div className='row' style={{ paddingTop: "40px" }}>
                <div className='col col-sm-2 col-md-3 col-lg-4' />
                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                    <h5 className="card-title">
                        <span>{t("forms.nutrientes")}</span>
                    </h5>
                </div>
            </div>
            <div className='flexDisplay justify-content-between'>
                <Button type="button" data-toggle="collapse"
                    data-target=".multi-collapse" aria-expanded="false"
                    aria-controls="multiCollapse1 multiCollapse2"
                    disabled={disabled} rounded text aria-label="Add" style={{color:"#000000"}}
                >
                    <FontAwesomeIcon icon={faPlus} size="lg" onClick={(event) => {
                        setIsEditing(false);
                        clearInputs();
                    }}
                    />
                </Button>
                <Button type="button" rounded text aria-label="Clear" style={{color:"#000000"}} >
                    <FontAwesomeIcon icon={faTrash} size="lg" onClick={(event) => {
                        if (Array.isArray(tableNutrientes) && tableNutrientes.length > 0) {
                            if (!promiseWrapper3.current) return;
                            promiseWrapper3.current?.getPromiseAnswer()?.then((del) => {
                                if (!del) return;
                                setTableNutrientes([]);
                            });
                        }
                    }}
                    />
                </Button>
            </div>
            <DataTablePrime
                t={t}
                tableName="EditNutrientesDialogTable"
                items={tableNutrientes}
                editableRow
                editFunction= {(event, rowData) => {
                    setIsEditing(true);
                    setCurrentNutriente(rowData);
                    percentRef2.current.value=rowData.porcentaje;
                }}
                editButtonProps = {{
                    "data-toggle":"collapse",
                    "data-target":".multi-collapse",
                    "aria-expanded":"false",
                    "aria-controls":"multiCollapse1 multiCollapse2"}}
                deletableRow
                deleteFunction= {async (event, rowData) => {
                    if (!promiseWrapper3.current) return;
                    await promiseWrapper4.current?.getPromiseAnswer()?.then((del) => {
                        if (!del) return;
                        const index = tableNutrientes?.findIndex(m => m.nutriente_id === rowData.nutriente_id);
                        if(index >=0){
                            const newArray = tableNutrientes.slice(0, index).concat(tableNutrientes.slice(index + 1));
                            setTableNutrientes(newArray);
                        }
                    });
                }}
                fields={[
                    {field:"nutriente_id",header:names[0], bodyStyle:{textAlign:"center"}, hidden:true},
                    {field:"nombre",header:names[4], bodyStyle:{textAlign:"center"}},
                    {field:"porcentaje",header:names[5], body:templatePorcentaje,  bodyStyle:{textAlign:"center"}},
                ]}
            />
        </div >
    );
};

const fertiForm = "ferti_form";
class FertilizerForm extends Component {
    render() {
        const { status = {}, /* canEdit, */ data, t, handleSubmit, values, i18n, names, nutrientes, tableNutrientes, setTableNutrientes } = this.props;
        if (!data) return null;

        /* const showAll = !Array.isArray(allowList) || !allowList.length;
        const isEdit = canEdit && status.edit; */

        /* if (dilucionRef.current) {
            if (dilucionRef.current.value > 100) dilucionRef.current.value = 100;
            if (dilucionRef.current.value == 100) solubleRef.current.checked = false;
            if (dilucionRef.current.value < 100) solubleRef.current.checked = true;
        } */

        /*  if (!values?.soluble && !addMode) { data.dilucion = 100; values.dilucion = 100; } */
        if (values?.dilucion > 100) { data.dilucion = 100; values.dilucion = 100; }
        if (values?.dilucion < 0) { data.dilucion = 0; values.dilucion = 0; }
        /* if (values?.dilucion == 100) { data.soluble = false; values.soluble = false; }
        if (values?.dilucion < 100) { data.soluble = true; values.soluble = false; } */
        return (
            <div>
                <div>
                    <Form id={fertiForm} onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <FormRow
                                    dato1={data.fertilizante && (data.fertilizante[i18n.language] ?? data.fertilizante["en"])}
                                    nombre1={t("forms.fertilizante")}
                                    campo1="fertilizante"
                                />

                                <FormRow
                                    /* edit={isEdit} */
                                    edit
                                    /*  dato1={data.dilucion} */
                                    dato1={t("general.number_unit", { value: { number: data.dilucion, unit: "%" } })}
                                    nombre1={t("forms.dilucion")}
                                    campo1="dilucion"
                                    type1="number"
                                    step1="0.01"
                                    unit1="%"
                                />

                                <FormRow
                                    edit
                                    dato1={data.descripcion}
                                    nombre1={t("personal.description")}
                                    campo1="descripcion"
                                    type1="text"
                                />

                                <EditNutrientsTable
                                    names={names}
                                    nutrientes={(Array.isArray(data.nutrientes_estanque) && data.nutrientes_estanque.length) ? data.nutrientes_estanque : data.nutrientes_defecto}
                                    listaNutrientes={nutrientes || []}
                                    t={t}
                                    fertilizante_id={data.fertilizante_id}
                                    tableNutrientes={tableNutrientes}
                                    setTableNutrientes={setTableNutrientes}
                                />
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        const data = Object.assign({}, props.data);
        return {
            fertilizante_id: data.fertilizante_id,
            fertilizante: data.fertilizante,
            dilucion: data.dilucion,
            soluble: data.soluble,
            descripcion: data.descripcion
        };
    },
    enableReinitialize: true,
    handleSubmit: (values, { props }) => {
        /* props.updateData(values, props); */
    }
})(withTranslation()(FertilizerForm));

const FertilizersTable = ({ farmId, hydraId, fertilizantes, t, i18n, setInfo }) => {

    const [dialogState, setDialogState] = useState({ visible: false });
    const [dataSource,_] = useContext(FarmContext);
    const [dialogEditState, setDialogEditState] = useState({ visible: false });
    const [disableAddNut, setDisableAddNut] = useState(true);
    const [listaNutrientes, setListaNutrientes] = useState([]);

    const [tableFertilizantes, setTableFertilizantes] = useState(null);
    const copiaFertilizantes = useMemo(() => {
        if(fertilizantes && fertilizantes.slice(0)){
            setTableFertilizantes(fertilizantes && fertilizantes.slice(0));
        }else{
            setTableFertilizantes([]);
        }
        return fertilizantes && fertilizantes.slice(0);
    }, [fertilizantes]);
    const [currentFertilizante, setCurrentFertilizante] = useState(true);
    const [currentNutriente, setCurrentNutriente] = useState(null);
    const formikRef = useRef(false);
    const promiseWrapper = useRef(null);
    const promiseWrapper2 = useRef(null);
    const promiseWrapper3 = useRef(null);
    const [dialogExist, setDialogExist] = useState(false);
    const [dialogEditExist, setDialogEditExist] = useState(false);

    const tableRef = useRef(null);
    const solubleRef = useRef(null);
    const descripcionRef = useRef(null);
    const dilucionRef = useRef(null);
    const percentRef = useRef(null);
    const addIconRef = useRef(null);

    const [loading, setLoading] = useState(false);

    const [tableNutrientes, setTableNutrientes] = useState(null);
    const names = useMemo(() => [
        "ID", t("general.name"), t("forms.soluble"), t("forms.dilucion"),
        t("forms.nutriente"), t("forms.porcentaje"), t("forms.opciones"), t("personal.description"), t("forms.nutrientes")
    ], [t]);

    const [maxRecom, setMaxRecom] = useState(null);
    const btnVerdeRef = useRef(false);

    const lang = i18n.language;

    const [types, dispatch] = useContext(TypesContext);
    const { [`${farmId}/fertilizantes`]: fertilizantesTypes } = types[lang] || {};

    if (!fertilizantesTypes) dispatch({ type: "get", lang, path: `${farmId}/fertilizantes` });

    const newFertilizantes = useMemo(() => {
        if(fertilizantesTypes){
            const sortedFertilizantes = [...fertilizantesTypes];
            sortedFertilizantes.sort((a, b) => {
                const nameA = a.nombre.toUpperCase();
                const nameB = b.nombre.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
            return sortedFertilizantes;
        }
    }, [fertilizantesTypes]);

    const [fertiDataSource, setFertiDataSource] = useState(null);

    const clearInputs = () => {
        if (percentRef.current) {
            percentRef.current.value = null;
        }
        setCurrentNutriente(null);
    };

    const { templateNutrientes, templateFertilizante, /* templateSoluble, */ templateDilucion, templateDescripcion, templatePorcentaje } = useMemo(() => {
        const templateNutrientes = ({ nutrientes_estanque }) => {
            if (!nutrientes_estanque || nutrientes_estanque === null || !nutrientes_estanque.length) return "-";
            return (
                Array.isArray(nutrientes_estanque) && nutrientes_estanque.map((n, index) => {
                    return (
                        n !== ", " && <span className="param-properties" key={`${index}-${n}`}>{`${n.nombre} - ${t("general.number_unit", { value: { number: n.porcentaje, unit: "%" } })}`}<br /></span>
                    );
                })
            );
        };

        const templateFertilizante = ({ fertilizante }) => {
            if (Object.keys(fertilizante??{}).length === 0 || fertilizante === "" || fertilizante === null || fertilizante === undefined) return "-";
            const traduccion = fertilizante[i18n.language] ?? fertilizante["en"];
            return (
                <span className="param-properties">{traduccion}</span>
            );
        };

        /* const templateSoluble = ({ soluble }) => {
            return (<span>{soluble ? t("general.answerYes") : t("general.answerNo")}</span>)
        } */

        const templateDilucion = ({ dilucion }) => {
            if (dilucion === null || dilucion === undefined) return "-";
            return (<span className="param-properties">{t("general.number_unit", { value: { number: dilucion, unit: "%" } })}</span>);
        };

        const templateDescripcion = ({ descripcion }) => {
            if (descripcion === null || descripcion === undefined || descripcion === "" || descripcion === " ") return "-";
            return (<span className="param-properties">{descripcion}</span>);
        };

        const templatePorcentaje = ({ porcentaje }) => {
            if (porcentaje === null || porcentaje === undefined) return "-";
            return (<span className="param-properties">{t("general.number_unit", { value: { number: porcentaje, unit: "%" } })}</span>);
        };

        return { templateNutrientes, templateFertilizante, /* templateSoluble, */ templateDilucion, templateDescripcion, templatePorcentaje };
    }, [t]);

    const buttons = useMemo(() => [{
        // do not handle submits on enter (prevent double submit, as formik handles it also)
        click: (e) => {
            if (e.keyCode == 13) {
                e.preventDefault();
                return false;
            }
            const dilucionValue = parseFloat(dilucionRef.current?.value || 0);

            const fertilizante = {
                hidraulica_id: parseInt(hydraId),
                fertilizante_id: currentFertilizante?.fertilizante_id,
                soluble: (dilucionValue < 100 ? true : false),
                dilucion: dilucionValue,
                descripcion: descripcionRef.current?.value,
                nutrientes: tableNutrientes
            };

            const endpoint = `/farms/${farmId}/estanque/${fertilizante.hidraulica_id}/fertilizante`;
            if (fertilizante.fertilizante_id) {
                RestAPI.post("apiAdminDropControl", endpoint, { body: fertilizante })
                    .then(res => JSON.parse(JSON.stringify(res)))
                    .then((data) => {
                        data.hidraulica_id = parseInt(hydraId);
                        setTableFertilizantes(prevTableFert => [...prevTableFert, data]);
                        setInfo(prev => ({...prev, data:{...prev.data, fertilizantes:[...prev.data.fertilizantes,data]}}));
                        toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                        setDialogState({ visible: false });

                        dilucionRef.current.disabled = disableAddNut;
                        dilucionRef.current.value = 0;
                        setTableNutrientes([]);
                        setDialogExist(false);
                    })
                    .catch(err => {
                        toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                        console.error(err);
                        return [];
                    });
            } else {
                setDialogState({ visible: false });
                toast.info(t("forms.toastInfo"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
            }
        },
        buttonModel: { cssClass: "e-primary", content: t("forms.save"), isPrimary: true, disabled: false }
    }, {
        click: () => {
            setDialogState({ visible: false });
            setDialogExist(false);
            setDisableAddNut(true);
        },
        buttonModel: { cssClass: "e-flat", content: t("forms.cancel"), disabled: false }
    }], [t, hydraId, tableNutrientes]);

    const are_arrs_match = (arr1, arr2) => {
        if (arr1 === null && arr2 === null) {
            return false;
        }
        if (arr1 === null || arr2 === null) {
            return true;
        }
        if (arr1 === undefined && arr2 === undefined) {
            return false;
        }
        if (arr1 === undefined || arr2 === undefined) {
            return true;
        }
    };

    const updateButtons = useMemo(() => [{
        click: (e) => {
            if (e.keyCode == 13) {
                e.preventDefault();
                return false;
            }
            let isUpdate = false;
            const values = formikRef.current.values;
            const nutrientes = tableNutrientes;

            const fertilizante = {
                hidraulica_id: parseInt(hydraId),
                fertilizante_id: values.fertilizante_id,
                dilucion: values.dilucion,
                soluble: (values.dilucion < 100 ? true : false),
                descripcion: values.descripcion,
                nutrientes: nutrientes,
                nutrientes_estanque: nutrientes,
            };

            let fertilizanteAnterior = null;
            if (Array.isArray(tableFertilizantes)) {
                fertilizanteAnterior = tableFertilizantes.find(f => f.fertilizante_id == fertilizante.fertilizante_id);
            }

            if (fertilizante.fertilizante_id !== fertilizanteAnterior.fertilizante_id) isUpdate = true;

            if (fertilizante.dilucion !== fertilizanteAnterior.dilucion) isUpdate = true;

            if (fertilizante.descripcion !== fertilizanteAnterior.descripcion) isUpdate = true;

            /*  if (fertilizante.soluble !== fertilizanteAnterior.soluble) isUpdate = true; */

            if (are_arrs_match(fertilizante.nutrientes, fertilizanteAnterior.nutrientes_estanque) === true) isUpdate = true;

            if (fertilizanteAnterior === null) isUpdate = true;

            if (Array.isArray(fertilizante.nutrientes_estanque) && Array.isArray(fertilizanteAnterior.nutrientes_estanque)) {
                if (fertilizante.nutrientes_estanque.length !== fertilizanteAnterior.nutrientes_estanque.length) { isUpdate = true; }
                for (let index = 0; index < fertilizante.nutrientes_estanque.length; index++) {
                    const element = fertilizante.nutrientes_estanque[index];
                    if (fertilizante.nutrientes_estanque.length === fertilizanteAnterior.nutrientes_estanque.length) {
                        if (fertilizante.nutrientes_estanque[index].porcentaje != fertilizanteAnterior.nutrientes_estanque[index].porcentaje) {
                            isUpdate = true;
                        }
                    } else {
                        isUpdate = true;
                    }
                }
            }

            if (!isUpdate) {
                setDialogEditState({ visible: false });
                toast.info(t("forms.toastInfo"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
            } else {
                const endpoint = `/farms/${farmId}/estanque/${fertilizante.hidraulica_id}/updateFertilizante`;
                RestAPI.post("apiAdminDropControl", endpoint, { body: fertilizante })
                    .then(res => JSON.parse(JSON.stringify(res)))
                    .then((data) => {
                        data.hidraulica_id = data.estanque_id;
                        const index = tableFertilizantes?.findIndex(f => f.fertilizante_id === data.fertilizante_id);
                        tableFertilizantes[index] = data;
                        toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                        setDialogEditState({ visible: false });
                        setDialogEditExist(false);
                    })
                    .catch(err => {
                        toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                        console.error(err);
                        return [];
                    });
            }
        },
        buttonModel: { cssClass: "e-primary", content: t("forms.save"), isPrimary: true, disabled: false }
    }, {
        click: () => {
            setDialogEditState({ visible: false });
            setDialogEditExist(false);
        },
        buttonModel: { cssClass: "e-flat", content: t("forms.cancel"), disabled: false }
    }], [t, hydraId, tableNutrientes]);

    //obtener lista de todos los nutrientes
    useEffect(() => {
        const param = "/farms/nutrientes";
        RestAPI.get("apiAdminDropControl", param)
            .then(res => JSON.parse(JSON.stringify(res)))
            .then((data) => {
                data?.sort((a, b) => {
                    const nameA = a.nombre.toUpperCase();
                    const nameB = b.nombre.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });
                setListaNutrientes(data);
            })
            .catch(err => { console.error(err); return []; });
    }, []);
    return (<>
        <PromiseWrapper
            ref={promiseWrapper}
            yesText={t("general.answerYes")} noText={t("general.answerNo")}
            headerText={t("general.confirm")} contentText={t("forms.borrarFertiMsg")}
        />

        <PromiseWrapper
            ref={promiseWrapper2}
            yesText={t("general.answerYes")} noText={t("general.answerNo")}
            headerText={t("general.confirm")} contentText={t("forms.clearTableMsg")}
        />

        <PromiseWrapper
            ref={promiseWrapper3}
            yesText={t("general.answerYes")} noText={t("general.answerNo")}
            headerText={t("general.confirm")} contentText={t("forms.borrarNutMsg")}
        />

        <div>
            {dialogExist ?
                <DialogComponentWrapper
                    containerId='dialogAddFerti'
                    animationSettings={{ effect: "Zoom", duration: 300, delay: 0 }}
                    isModal
                    visible={dialogState.visible}
                    close={(event) => { setDialogState(false); setCurrentFertilizante(null); setTableNutrientes([]); }}
                    width='770px'
                    height='50%'
                    showCloseIcon
                    header={dialogState.headerText}
                    buttons={buttons}
                    t={t}
                    dialogState={dialogState}
                    setDialogState={setDialogState}
                >
                    <div>
                        {loading && <LoadingDialog targetId="dialogAddFerti" />}
                        <div className="row linea-formulario">
                            <div className="col-12 col-md-6 text-md-right mtem-05">
                                <label className="boldie">{t("forms.fertilizante")}</label>
                            </div>
                            <div className="mb-2 col-md-6">
                                <DropdownPrime
                                    value={currentFertilizante}
                                    showClear={false}
                                    onChange={async (e) => {
                                        setLoading(true);
                                        setCurrentFertilizante(e?.value);
                                        const dilucion = parseFloat(e?.value?.dilucion);
                                        if (hydraId && e?.value?.fertilizante_id) {
                                            const param = `/farms/fertilizante/${e?.value?.fertilizante_id}`;
                                            RestAPI.get("apiAdminDropControl", param)
                                                .then(res => JSON.parse(JSON.stringify(res)))
                                                .then((data) => {
                                                    if (data === undefined || data === null || !data.length) {
                                                        setTableNutrientes([]);
                                                    } else {
                                                        setTableNutrientes([]);
                                                        setTableNutrientes(data);
                                                    }
                                                    setLoading(false);
                                                    if (dilucionRef.current) dilucionRef.current.value = dilucion;
                                                    setDisableAddNut(false);
                                                })
                                                .catch(err => { console.error(err); return []; });
                                        }else{
                                            setLoading(false);
                                            setTableNutrientes([]);
                                        }
                                    }}
                                    options={fertiDataSource} optionLabel="nombre"
                                    placeholder={t("forms.pHolderSelect")}
                                    name="ddlFertilizante"
                                />
                            </div>
                        </div>

                        <div className="row linea-formulario">
                            <div className="col-12 col-md-6 text-md-right mtem-05">
                                <label className='boldie'>{t("forms.dilucion")}</label>
                            </div>
                            <div className="mb-2 input-group col-md-6">
                                <div className="p-0 unit-input-content">
                                    <input id="addDilucion" ref={dilucionRef} name="addDilucion"
                                        max={100} min={0} step={0.01}
                                        placeholder="0"
                                        className="form-control text-center text-md-left fertiForm"
                                        type="number"
                                        disabled={disableAddNut}
                                        onChange={() => {

                                            if (dilucionRef.current) {
                                                if (dilucionRef.current.value > 100) dilucionRef.current.value = 100;
                                                if (dilucionRef.current.value < 0) dilucionRef.current.value = 0;
                                                /* if (dilucionRef.current.value == 100) solubleRef.current.checked = false;
                                                if (dilucionRef.current.value < 100) solubleRef.current.checked = true; */
                                            }
                                        }}
                                    />
                                    <p className="unit-edit">%</p>
                                </div>
                            </div>
                        </div>
                        <div className="row linea-formulario">
                            <div className="col-12 col-md-6 text-md-right mtem-05">
                                <label className='boldie'>{t("personal.description")}</label>
                            </div>
                            <div className="mb-2 input-group col-md-6">
                                <div className="p-0">
                                    <input ref={descripcionRef}
                                        maxLength={30}
                                        placeholder={t("personal.description")}
                                        className="form-control text-center text-md-left fertiForm"
                                        type="text"
                                        disabled={disableAddNut}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <div className="row linea-formulario">
                            <div className="col-12 col-md-6 text-md-right mtem-05">
                                <label className="boldie">{t("forms.soluble")}</label>
                            </div>

                            <div className="mb-2 input-group col-md-6">
                                <div className="p-0">
                                    <input name="addSoluble" ref={solubleRef}
                                        type="checkbox" className="form-control text-center text-md-left"
                                        placeholder={t("forms.soluble")} disabled={disableAddNut}
                                         />
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            <div className="col">
                                <div className="collapse multi-collapse" id="multiCollapseExample1" style={{ paddingTop: "30px" }}>
                                    <div className="card card-body">
                                        <form id="addNutForm"
                                            onSubmit={async (e) => {
                                                setLoading(true);
                                                e.preventDefault();
                                                if (currentNutriente?.nutriente_id && percentRef.current.value) {
                                                    const { porcentaje } = e.target.elements;
                                                    const idNutSelected = currentNutriente.nutriente_id;
                                                    if (Array.isArray(tableNutrientes) && !tableNutrientes.filter(n => n.nutriente_id == idNutSelected).length) {
                                                        const nutriente = listaNutrientes.find(n => n.nutriente_id == idNutSelected);
                                                        const fertilizante_id = currentFertilizante?.fertilizante_id;
                                                        const objNutriente = {
                                                            fertilizante_id: fertilizante_id,
                                                            nombre: nutriente.nombre,
                                                            nutriente_id: nutriente.nutriente_id,
                                                            porcentaje: parseFloat(porcentaje.value)
                                                        };
                                                        setTableNutrientes(prevTableNutrientes => [...prevTableNutrientes, objNutriente]);
                                                        clearInputs();
                                                    }
                                                    setLoading(false);
                                                }
                                            }}
                                        >

                                            <div className="row linea-formulario">
                                                <div className="col-2">
                                                    <label className="boldie">{t("forms.nutriente")}</label>
                                                </div>
                                                <div className="mb-2 col-4 d-block text-left">
                                                    <DropdownPrime
                                                        small
                                                        value={currentNutriente}
                                                        onChange={(e) => {
                                                            setCurrentNutriente(e.value);
                                                            setDisableAddNut(false);
                                                        }}
                                                        options={listaNutrientes} optionLabel="nombre"
                                                        placeholder={t("forms.pHolderSelect")}
                                                        name="ddlNutrientes"
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <label className="boldie">{t("forms.porcentaje")}</label>
                                                </div>
                                                <div className="col-4 d-block">
                                                    <div className="p-0 unit-input-content">
                                                        <input ref={percentRef} name="porcentaje" placeholder="0" min={0} max={100} step={0.01}
                                                            className="e-control e-dropdownlist e-input" type="number"/*  step=".01" */
                                                            onChange={() => {
                                                                /* btnVerdeRef.current.disabled = false; */
                                                                setMaxRecom(null);
                                                                if (percentRef.current && percentRef.current.value > 100) percentRef.current.value = 100;
                                                                if (percentRef.current && percentRef.current.value < 0) percentRef.current.value = 0;
                                                                if (tableNutrientes) {
                                                                    let per = 0;
                                                                    tableNutrientes.forEach(d => {
                                                                        per = per + d.porcentaje;
                                                                    });
                                                                    const recomm = 100 - per;
                                                                    if (percentRef.current && percentRef.current.value > recomm) {
                                                                        setMaxRecom(t("forms.percentMsg"));
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                        <p className="unit-edit">%</p>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="row pt-2">
                                                <div className="col-6 text-right">
                                                    <button className='border-0 bg-transparent p-0' type="submit" form="addNutForm"
                                                        data-toggle="collapse"
                                                        data-target=".multi-collapse" aria-expanded="false"
                                                        aria-controls="multiCollapseExample1 multiCollapseExample2"
                                                        ref={btnVerdeRef}
                                                    >
                                                        <FontAwesomeIcon id="greenCheckIcon" name="greenCheckIcon" className='btnEdit pointer' size="lg" style={{ color: "green" }} icon={faCheckCircle}
                                                            type="submit" form="addNutForm"
                                                        >{t("forms.save")}</FontAwesomeIcon>
                                                    </button>
                                                </div>

                                                <div className="col-6 text-left">
                                                    <button type="button" className='border-0 bg-transparent p-0'
                                                        data-toggle="collapse"
                                                        data-target=".multi-collapse" aria-expanded="false"
                                                        aria-controls="multiCollapseExample1 multiCollapseExample2"
                                                        onClick={(e) => {
                                                            setCurrentNutriente(null);
                                                            percentRef.current.value = 0;
                                                        }}
                                                    >
                                                        <FontAwesomeIcon className='btnEdit pointer' size="lg" style={{ color: "tomato" }} icon={faTimesCircle}>{t("forms.cancel")}</FontAwesomeIcon>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <span className="param-properties spanErrorMsg">{maxRecom}</span>

                        <div className='row' style={{ paddingTop: "40px" }}>
                            <div className='col col-sm-2 col-md-3 col-lg-4' />
                            <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                <h5 className="card-title">
                                    <span>{t("forms.nutrientes")}</span>
                                </h5>
                            </div>
                        </div>

                        {/* TABLA PARA AGREGAR NUTRIENTES */}
                        {/* TABLA PARA AGREGAR NUTRIENTES */}
                        {/* TABLA PARA AGREGAR NUTRIENTES */}
                        {/* TABLA PARA AGREGAR NUTRIENTES */}

                        <div className='flexDisplay justify-content-between'>
                            <Button type="button" data-toggle="collapse"
                                data-target=".multi-collapse" aria-expanded="false"
                                aria-controls="multiCollapseExample1 multiCollapseExample1"
                                disabled={disableAddNut} rounded text aria-label="Add" style={{color:"#000000"}}
                            >
                                <FontAwesomeIcon icon={faPlus} size="lg" onClick={(event) => {
                                }}
                                />
                            </Button>
                            <Button type="button" rounded text aria-label="Clear" style={{color:"#000000"}} >
                                <FontAwesomeIcon icon={faTrash} size="lg" onClick={(event) => {
                                    if (Array.isArray(tableNutrientes) && tableNutrientes.length > 0) {
                                        if (!promiseWrapper2.current) return;
                                        promiseWrapper2.current?.getPromiseAnswer()?.then((del) => {
                                            if (!del) return;
                                            setTableNutrientes([]);
                                        });
                                    }
                                }}
                                />
                            </Button>
                        </div>
                        <DataTablePrime
                            t={t}
                            tableName="NutrientesDialogTable"
                            items={tableNutrientes}
                            deletableRow
                            deleteFunction= {async (event, rowData) => {
                                if (!promiseWrapper3.current) return;
                                await promiseWrapper3.current?.getPromiseAnswer()?.then((del) => {
                                    if (!del) return;
                                    const index = tableNutrientes?.findIndex(m => m.nutriente_id === rowData.nutriente_id);
                                    if(index >=0){
                                        const newArray = tableNutrientes.slice(0, index).concat(tableNutrientes.slice(index + 1));
                                        setTableNutrientes(newArray);
                                    }
                                });
                            }}
                            fields={[
                                {field:"nutriente_id",header:names[0], bodyStyle:{textAlign:"center"}, hidden:true},
                                {field:"nombre",header:names[4], bodyStyle:{textAlign:"center"}},
                                {field:"porcentaje",header:names[5], body:templatePorcentaje,  bodyStyle:{textAlign:"center"}},
                            ]}
                        />
                    </div>
                </DialogComponentWrapper>
                : null}
        </div >

        {dialogEditExist ?
            <DialogComponentWrapper formikRef={formikRef} containerId="ferti-table-form"
                t={t} dialogState={dialogEditState} setDialogState={setDialogEditState}
                searchButton={!dialogEditState.data}
                buttons={updateButtons}
                width="770px"
            >
                <FormikForm
                    innerRef={formikRef}
                    canEdit
                    isTableDialog
                    alert={dialogEditState.alert}
                    hidden={!dialogEditState.visible}
                    msg={dialogEditState.edit ? "forms.fillData" : null}
                    data={dialogEditState.data}
                    edit={dialogEditState.edit}
                    names={names}
                    nutrientes={listaNutrientes}
                    t={t}
                    i18n={i18n}
                    tableNutrientes={tableNutrientes}
                    setTableNutrientes={setTableNutrientes}
                />
            </DialogComponentWrapper>
            : null}
        {dataSource?.dataFarm?.can_edit?
            <DivPortal container="fertiTableToolbar">
                <FontAwesomeIcon className='btnEdit pointer text-dark' size="lg" icon={faPlus}
                    onClick={() => {
                        setDialogExist(true);
                        setDialogState({ visible: true, headerText: t("forms.agregarFerti") });
                        /* setCurrentFertilizante(null); */
                        setDisableAddNut(true);
                        setMaxRecom(null);
                        newFertilizantes;
                        let newFertis = newFertilizantes;

                        if (tableFertilizantes && Array.isArray(tableFertilizantes) && tableFertilizantes.length > 0) {
                            Array.isArray(tableFertilizantes) && tableFertilizantes.forEach(d => {
                                newFertis = newFertis.filter(f => f.fertilizante_id !== d.fertilizante_id);
                            });
                            setFertiDataSource(newFertis);
                        } else {
                            setFertiDataSource(newFertilizantes);
                        }
                    }}
                />
            </DivPortal>:
            null}

        {/* TABLA PRINCIPAL */}
        {/* TABLA PRINCIPAL */}
        {/* TABLA PRINCIPAL */}
        {/* TABLA PRINCIPAL */}

        <DataTablePrime
            t={t}
            tableName="FertiTablePrime"
            items={tableFertilizantes}
            editableRow={dataSource?.dataFarm?.can_edit}
            editFunction= {async (event, rowData) => {
                if (!rowData) return;
                setDialogEditExist(true);
                setDialogEditState({
                    data: rowData, visible: true, headerText: t("forms.editarFertilizante"), fertilizante_id: rowData.fertilizante_id
                });
            }}
            rowDataBoundFunction= {(rowData) => {
                if (rowData) return true;
                else return false;
            }}
            deletableRow={dataSource?.dataFarm?.can_edit}
            deleteFunction= {async (event, rowData) => {
                const id_fertilizante = rowData.fertilizante_id;
                const hidra_id = rowData.hidraulica_id;
                if (!rowData) return;
                if (!promiseWrapper.current) return;
                promiseWrapper.current?.getPromiseAnswer()?.then((del) => {
                    if (!del) return;
                    const endpoint = `/farms/${farmId}/estanque/${hidra_id}/deleteFertilizante/${id_fertilizante}`;
                    RestAPI.post("apiAdminDropControl", endpoint)
                        .then(res => {
                            const data = JSON.parse(JSON.stringify(res));
                            if(data.del1 || data.del2){
                                const index = tableFertilizantes?.findIndex(m => m.fertilizante_id === id_fertilizante);
                                const newArray = tableFertilizantes.slice(0, index).concat(tableFertilizantes.slice(index + 1));
                                setInfo(prev => ({...prev, data:{...prev.data, fertilizantes:newArray}}));
                                setTableFertilizantes(newArray);
                                toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                            }
                            else{
                                toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                            }
                        })
                        .catch(err => {
                            toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                            console.error(err);
                            return [];
                        });
                });
            }}
            fields={[
                {field:"fertilizante_id",header:names[0], bodyStyle:{textAlign:"center"}, hidden:true},
                {field:"fertilizante",header:names[1], body:templateFertilizante, bodyStyle:{textAlign:"center"}, sortable:true},
                {field:"descripcion",header:names[7], body:templateDescripcion, bodyStyle:{textAlign:"center"}, sortable:true},
                {field:"dilucion",header:names[3], body:templateDilucion, bodyStyle:{textAlign:"center"}, sortable:true},
                {field:"nutrientes_estanque",header:names[8], body:templateNutrientes, bodyStyle:{textAlign:"center"}, sortable:true},
            ]}
        />
    </>);
};

export { FertilizersTable };
